import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Snackbar,
  Alert,
  Box,
  Button,
  Paper,
  Tooltip
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/api';

const SearchLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

  const navigate = useNavigate();

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await apiFetch('/api/admin/search-logs');
      if (res.success) {
        setLogs(res.data);
      } else {
        throw new Error(res.message || 'Failed to fetch logs');
      }
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Box display="flex" justifyContent="space-between" alignItems="center" my={3}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/nomas')}
        >
          Back to Dashboard
        </Button>
        <Typography variant="h5" fontWeight="bold" color="primary.dark">
          Search Logs
        </Typography>
      </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <Paper elevation={3}>
          <Table>
            <TableHead sx={{ backgroundColor: '#0d1b2a' }}>
              <TableRow>
                <TableCell sx={{ color: 'white' }}>User</TableCell>
                <TableCell sx={{ color: 'white' }}>Email</TableCell>
                <TableCell sx={{ color: 'white' }}>Search Term</TableCell>
                <TableCell sx={{ color: 'white' }}>IP Address</TableCell>
                <TableCell sx={{ color: 'white' }}>Location</TableCell>
                <TableCell sx={{ color: 'white' }}>User Agent</TableCell>
                <TableCell sx={{ color: 'white' }}>Timestamp</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map((log) => (
                <TableRow key={log._id}>
                  <TableCell>{log.userId?.username || 'Guest'}</TableCell>
                  <TableCell>{log.userId?.email || '-'}</TableCell>
                  <TableCell>{log.searchTerm}</TableCell>
                  <TableCell>{log.ip || '-'}</TableCell>
                  <TableCell>{log.location || '-'}</TableCell>
                  <TableCell>
                    <Tooltip title={log.userAgent || 'Unknown'}>
                      <span>
                        {log.userAgent?.substring(0, 20) || 'Unknown'}
                        {log.userAgent?.length > 20 && '...'}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell>{new Date(log.createdAt).toLocaleString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default SearchLogs;
